import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NewRoofCostZipFormComponent } from '../new-roof-cost-zip-form/new-roof-cost-zip-form.component';
import { StickyZipAnchorDirective } from '../../../../shared/directives/sticky-zip-anchor.directive';

@Component({
  selector: 'app-new-roof-cost-banner',
  standalone: true,
  imports: [NewRoofCostZipFormComponent, StickyZipAnchorDirective],
  templateUrl: './new-roof-cost-banner.component.html',
  styleUrl: './new-roof-cost-banner.component.scss',
})
export class NewRoofCostBannerComponent {
  @Input() fetchedZipcode = '';
  @Input() zipValue = '';
  @Output() zipValueChange = new EventEmitter<string>();
}
